/*
  Stones: 다이얼로그에 보여줄 에러 메시지에 Locale 기능을 추가하기 위한 Object입니다.
*/

const dialogInfo = {
  // 예시
  ERROR_001: { ko: '아이디 또는 비밀번호가 일치하지 않습니다.', en: 'Invalid ID or Password' },
  ERROR_002: { ko: '인증번호가 틀립니다.', en: 'Please Enter correct Auth code' },
  ERROR_003: { ko: '입력 정보에 일치하는 계정이 없습니다.', en: 'Can not find ID from your input.' },
  ERROR_004: { ko: '중복된 ID 입니다. 다른 ID를 사용하세요.', en: 'You can not use this id.' },
  ERROR_005: { ko: '요청에 실패하였습니다.', en: 'Request Failed.' },
  ERROR_006: { ko: '중복된 조직명 입니다. 다른 조직명을 사용하세요.', en: 'You can not use this.' },
  ERROR_007: { ko: '매니페스트가 올바르지 않습니다.', en: 'Manifest is not grammatically correct.' },
  ERROR_008: { ko: '딕셔너리가 올바르지 않습니다.', en: 'Dictionary is not grammatically correct.' },
  ERROR_009: { ko: '시맨틱이 올바르지 않습니다.', en: 'Semantic is not grammatically correct.' },
  ERROR_010: { ko: '조직명이 입력되지 않았습니다.', en: 'Organization is blank.' },
  ERROR_011: { ko: '하위조직 등록에 실패했습니다.', en: 'Adding Sub Organization is failed' },
  ERROR_012: { ko: '비밀번호 변경에 실패했습니다.', en: 'Failed to change password.' },
  ERROR_013: { ko: '이미 등록된 메니페스트 버전입니다.', en: `It's a registered version of Menifest.` },
  ERROR_014: {
    ko: '다른 장소에서 해당 아이디로 접속하여 로그아웃 됩니다.',
    en: `You will be logged out by using the same ID from another location.`,
  },
  ERROR_015: {
    ko: '환자 병합에 성공하였으나, 환자 정보 변경에 실패하였습니다.',
    en: 'Patient merging was successful, but patient information change failed.',
  },
  ERROR_016: {
    ko: '환자 병합에 실패하였습니다.',
    en: 'Failed to merge patients.',
  },
  ERROR_017: { ko: '대리점명이 입력되지 않았습니다.', en: 'Distributor name is blank.' },
  ERROR_018: { ko: '대리점 코드가 입력되지 않았습니다.', en: 'Distributor code is blank.' },
  ERROR_019: {
    ko: '중복된 대리점명 입니다. 다른 대리점명을 사용하세요.',
    en: 'Distributor name already exists. Please choose another.',
  },
  ERROR_020: {
    ko: '중복된 대리점코드 입니다. 다른 대리점 코드를 사용하세요.',
    en: 'Distributor code already exists. Please choose another.',
  },
  ERROR_021: { ko: '이미 등록된 장치 시리얼입니다.', en: `This device serial is already registered.` },
  ERROR_022: { ko: '성별 값이 유효하지 않습니다.', en: `Invalid value for gender.` },
  ERROR_023: { ko: '등록할 수 없는 조직명입니다.', en: `Invalid organization name.` },
  ERROR_024: { ko: '등록할 수 없는 제조사코드입니다.', en: `Invalid manufacturer code.` },
  ERROR_025: { ko: '이 환자 정보는 이미 시스템에 존재합니다.', en: `This patient record already exists.` },
  ERROR_026: {
    ko: '환자의 생년월일은 오늘 이전의 날짜만 선택 가능합니다.',
    en: `The patient’s date of birth must be a date before today.`,
  },
  ERROR_027: { ko: '등록할 수 없는 모델입니다.', en: `Invalid model.` },

  INFO_0001: { ko: '인증번호가 전송되었습니다.', en: 'Send Auth Code.' },
  INFO_0002: { ko: '인증이 완료되었습니다.', en: 'Authentication Completed.' },
  INFO_0003: { ko: '이메일로 새 비밀번호를 전송했습니다.', en: 'Send new password to your email.' },
  INFO_0007: { ko: '만료된 JWT 토큰입니다.', en: 'JWT Expired.' },
  INFO_0010: { ko: '기능이 삭제되었습니다.', en: 'Function has been deleted' },
  INFO_0011: { ko: '기능이 등록되었습니다.', en: 'Function create success.' },
  INFO_0012: { ko: '권한이 삭제되었습니다.', en: 'Role has been deleted' },
  INFO_0013: { ko: '권한이 등록되었습니다.', en: 'Role create success.' },
  INFO_1000: { ko: '사용자가 등록되었습니다.', en: 'User create success.' },
  INFO_2000: { ko: '비밀번호가 변경되었습니다.', en: 'Password has been changed.' },
  INFO_2001: { ko: '권한이 변경되었습니다.', en: 'Role has been changed.' },
  INFO_2002: { ko: '매니페스트가 삭제되었습니다.', en: 'Manifest has been deleted.' },
  INFO_2003: { ko: '매니페스트가 등록되었습니다.', en: 'Manifest has been registered' },
  INFO_2004: { ko: '매니페스트가 수정되었습니다.', en: 'Manifest has been modified' },
  INFO_0000: { ko: '요청이 완료되었습니다.', en: 'Request finished.' },
  INFO_3000: { ko: '사용자 정보가 수정되었습니다.', en: 'User information has been modified.' },
  INFO_3001: { ko: '사용자가 삭제되었습니다.', en: 'User has been deleted.' },
  INFO_3002: { ko: '활성화 여부가 수정되었습니다.', en: 'User active status has been modified.' },
  INFO_3003: { ko: '메뉴가 등록되었습니다.', en: 'Menu create success.' },
  INFO_3004: { ko: '메뉴가 삭제되었습니다.', en: 'Menu has been deleted.' },
  INFO_3005: { ko: '메뉴 정보가 수정되었습니다.', en: 'Menu information has been modified.' },
  INFO_3006: { ko: '리소스가 등록되었습니다.', en: 'Resource create success.' },
  INFO_3007: { ko: '리소스가 삭제되었습니다.', en: 'Resource has been deleted.' },
  INFO_3008: { ko: '리소스 정보가 수정되었습니다.', en: 'Resource information has been modified.' },
  INFO_3009: { ko: '그룹 코드가 등록되었습니다.', en: 'Group Code create success.' },
  INFO_3010: { ko: '그룹 코드가 삭제되었습니다.', en: 'Group Code has been deleted.' },
  INFO_3011: { ko: '그룹 코드 정보가 수정되었습니다.', en: 'Group Code information has been modified.' },
  INFO_3012: { ko: '상세 코드가 등록되었습니다.', en: 'Detail Code create success.' },
  INFO_3013: { ko: '상세 코드가 삭제되었습니다.', en: 'Detail Code has been deleted.' },
  INFO_3014: { ko: '상세 코드 정보가 수정되었습니다.', en: 'Detail Code information has been modified.' },
  INFO_3015: { ko: '조직 관리 권한이 등록되었습니다.', en: 'Organization Management Permission create success.' },
  INFO_3016: { ko: '조직 관리 권한이 삭제되었습니다.', en: 'Organization Management Permission has been deleted.' },
  INFO_3017: { ko: '역할이 등록되었습니다.', en: 'Role create success.' },
  INFO_3018: { ko: '역할이 삭제되었습니다.', en: 'Role has been deleted.' },
  INFO_3019: { ko: '역할 정보가 수정되었습니다.', en: 'Role information has been modified.' },
  INFO_3020: { ko: '기능 정보가 수정되었습니다.', en: 'Function information has been modified.' },
  INFO_3021: { ko: '장치가 등록되었습니다', en: 'Device create success.' },
  INFO_3022: { ko: '장치가 삭제되었습니다', en: 'Device has been deleted.' },
  INFO_3023: { ko: '장치가 수정되었습니다', en: 'Device has been modified.' },
  INFO_3024: { ko: '조직이 등록되었습니다', en: 'Organization has been registered.' },
  INFO_3025: { ko: '조직이 삭제되었습니다', en: 'Organization has been deleted.' },
  INFO_3026: { ko: '조직이 수정되었습니다', en: 'Organization has been modified.' },
  INFO_3027: { ko: '환자가 등록되었습니다', en: 'Patient has been registered.' },
  INFO_3028: { ko: '환자가 삭제되었습니다', en: 'Patient has been deleted.' },
  INFO_3029: { ko: '환자가 수정되었습니다', en: 'Patient has been modified.' },
  INFO_3030: { ko: '장치가 연결되었습니다.', en: 'Device has been connected.' },
  INFO_3031: { ko: '장치 연결이 해제되었습니다.', en: 'Device has been disconnected.' },
  INFO_3032: { ko: '딕셔너리가 삭제되었습니다.', en: 'Dictionary has been deleted.' },
  INFO_3033: { ko: '딕셔너리가 수정되었습니다.', en: 'Dictionary has been modified.' },
  INFO_3034: { ko: '딕셔너리가 등록되었습니다.', en: 'Dictionary has been registered.' },
  INFO_3035: { ko: '시맨틱이 등록되었습니다.', en: 'Semantic has been registered.' },
  INFO_3036: { ko: '시맨틱이 수정되었습니다.', en: 'Semantic has been modified.' },
  INFO_3037: { ko: '시맨틱이 삭제되었습니다.', en: 'Semantic has been deleted.' },
  INFO_3101: { ko: '태그가 등록되었습니다.', en: 'Tag create success.' },
  INFO_3102: { ko: '태그가 삭제되었습니다.', en: 'Tag has been deleted.' },
  INFO_3103: { ko: '태그 정보가 수정되었습니다.', en: 'Tag information has been modified.' },
  INFO_3104: { ko: '인증번호를 전송하였습니다.', en: 'The verification code has been sent.' },
  INFO_3105: {
    ko: '이메일로 비밀번호 변경 링크가 전송되었습니다.',
    en: 'A password change link has been sent to your email.',
  },
  INFO_4000: { ko: 'ID 찾기에 성공했습니다.', en: 'Find Id success.' },
  INFO_3106: { ko: '인증번호가 틀렸습니다.', en: 'The verification code is incorrect.' },
  INFO_3107: { ko: '존재하지 않거나 잘못된 사용자 정보입니다.', en: 'Nonexistent or invalid user information.' },
  INFO_3108: { ko: 'ID를 입력해주세요.', en: 'ID is a required field' },
  INFO_3118: { ko: '이메일을 입력해주세요.', en: 'Email is a required field' },
  INFO_3109: { ko: '사용자 설정이 변경되었습니다.', en: 'User setting have been changed.' },
  INFO_3110: { ko: '필터가 등록되었습니다.', en: 'Filter create success.' },
  INFO_3111: { ko: '필터가 삭제되었습니다.', en: 'Filter has been deleted.' },
  INFO_3112: { ko: '필터 정보가 수정되었습니다.', en: 'Filter information has been modified.' },
  INFO_3113: { ko: '환자 병합이 완료되었습니다.', en: 'Patient merge is complete.' },
  INFO_3114: { ko: 'CMS 조직으로 등록되었습니다.', en: 'The organization is registered as a CMS organization.' },
  INFO_3115: { ko: '미어캣 리로드 요청에 성공했습니다.', en: 'Frontend reload request was successful', fr: '' },
  INFO_3116: {
    ko: '인증 시간이 초과되었습니다. 인증번호를 다시 요청해주세요.',
    en: 'The verification time has expired. Please request a new code.',
  },
  INFO_3117: {
    ko: '메일 발송에 실패했습니다. 잠시 후 다시 시도해주세요.',
    en: 'Failed to send email. Please try again later.',
  },
  INFO_3200: { ko: '시스템 설정 정보가 등록되었습니다.', en: 'System Setting Info created successfully.' },
  INFO_3201: { ko: '시스템 설정 정보가 삭제되었습니다.', en: 'System Setting Info has been deleted.' },
  INFO_3202: { ko: '시스템 설정 정보가 수정되었습니다.', en: 'System Setting Info has been modified.' },
  INFO_3301: { ko: '서버 정보가 등록되었습니다.', en: 'Server Info has been registered.' },
  INFO_3302: { ko: '서버 정보가 수정되었습니다.', en: 'Server Info has been modified.' },
  INFO_3303: { ko: '서버 정보가 삭제되었습니다.', en: 'Server Info has been deleted.' },
  INFO_3304: { ko: '중복된 키 입니다.', en: 'Duplicated Key entry.' },
  INFO_3305: { ko: '장치 연결 정보가 삭제되었습니다.', en: 'The device connection record has been deleted.' },
  INFO_3306: { ko: '장치 연결 정보가 수정되었습니다.', en: 'The device connection record has been updated.' },
  INFO_3307: {
    ko: '요청하신 기간에는 해당 장치가 다른 환자와 연결되어 있었습니다.',
    en: 'The device was connected to a different patient during the requested period.',
  },
  INFO_3308: {
    ko: '보고서 생성에 실패 하였습니다.',
    en: 'Failed to generate report.',
  },
  INFO_MEMO_REG: { ko: '환자 관리 기록이 등록되었습니다.', en: 'Care record has been registered.' },
  INFO_MEMO_EDIT: { ko: '환자 관리 기록이 수정되었습니다.', en: 'Care record has been modified.' },
  INFO_MEMO_DELETE: { ko: '환자 관리 기록이 삭제되었습니다.', en: 'Care record has been deleted.' },
  SUCCESS_0001: { ko: '사용 가능한 ID 입니다.', en: 'This Id is available.' },
  SUCCESS_0002: { ko: '사용 가능한 조직명 입니다.', en: 'This organization is available.' },
  SUCCESS_0003: { ko: '사용 가능한 대리점명입니다.', en: 'This distributor name is available.' },
  SUCCESS_0004: { ko: '사용 가능한 대리점 코드입니다.', en: 'This distributor code is available.' },
  SUCCESS_0005: { ko: '복사되었습니다.', en: 'Copied to clipboard.' },
  SUCCESS_0006: { ko: '사용 가능한 이메일입니다.', en: 'This email is available.' },
  INFO_DELETE_LICENSE: { ko: '라이선스가 삭제되었습니다', en: 'License has been deleted.' },
  INFO_CREATE_LICENSE: { ko: '라이선스가 등록되었습니다', en: 'License has been registered.' },
  INFO_APPROVE_LICENSE: { ko: '라이선스가 승인 되었습니다', en: 'License has been approved.' },
  INFO_REVOKE_LICENSE: { ko: '라이선스가 반려 되었습니다', en: 'License has been revoked.' },
  INFO_EDIT_LICENSE: { ko: '라이선스가 수정 되었습니다', en: 'License has ben edited.' },
  ERROR_COPY: { ko: '복사에 실패하였습니다', en: 'Could not copy to clipboard' },
  ERROR_USER_0001: { ko: '현재 비밀번호가 일치하지 않습니다.', en: 'Current password does not match.' },
  ERROR_USER_0002: { ko: '이미 사용 중인 아이디입니다.', en: 'This ID is already in use.' },
  ERROR_USER_0003: { ko: '이미 사용 중인 이메일입니다.', en: 'This email is already in use.' },
  ERROR_UNAUTHORIZED_0001: { en: 'You do not have permission', ko: '권한이 없습니다.' },
  INFO_APPROVE_ORDER: { ko: '주문이 승인 되었습니다', en: 'Order has been approved.' },
  INFO_DELETE_ORDER: { ko: '주문이 삭제되었습니다', en: 'The order has been deleted.' },
  INFO_CREATE_ORDER: { ko: '주문이 등록되었습니다', en: 'The order has been registered.' },
  INFO_EDIT_ORDER: { ko: '주문이 수정되었습니다', en: 'The order has been modified.' },
  INFO_CANCEL_ORDER: { ko: '주문이 취소되었습니다', en: 'The order has been canceled.' },
  INFO_CANCEL_APPROVE: { ko: '승인이 취소되었습니다', en: 'Approval has been canceled.' },
  // ERROR_REMOTE_SETTING: { ko: '오픈되지 않은 서비스입니다.', en: 'This service is currently unavailable.' },
  ERROR_REMOTE_QUERY: {
    ko: '원격 기기 쿼리에 실패했습니다. 다시 시도해주세요.',
    en: 'Remote query failed. Please try again',
  },
  ERROR_REMOTE_SETTING: {
    ko: '원격 기기 설정에 실패했습니다. 다시 시도해주세요 (500).',
    en: 'Remote setting failed. Please try again (500).',
  },
  ERROR_REMOTE_SETTING_INVALID: {
    ko: '원격 기기 설정에 실패했습니다 - INVALID 값입니다.',
    en: 'Remote setting failed - INVALID value.',
  },
  ERROR_REMOTE_SETTING_TIMEOUT: {
    ko: '원격 기기 설정에 실패했습니다 - TIMEOUT.',
    en: 'Remote setting failed - TIMEOUT.',
  },
  ERROR_REMOTE_SETTING_BIFLOW_MODE: {
    ko: 'Biflow On 시에는 flow 설정이 불가능합니다 - Biflow.',
    en: 'Flow setting is not possible when Biflow is On - Biflow.',
  },
  SUCCESS_REMOTE_SETTING: {
    ko: '원격 기기 설정에 성공했습니다.',
    en: 'Remote setting succeeded.',
  },
  INFO_REMOTE_SETTING_SAME_VALUE: {
    ko: '원격 기기 설정 값이 이전과 동일합니다.',
    en: 'Remote setting value is the same as before.',
  },
};

export default dialogInfo;
